var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5428 3.33506C9.75113 1.0934 7.4178 -0.414938 4.80946 0.101728C2.90113 0.485062 1.35113 2.01006 0.95113 3.9184C0.267797 7.14339 2.7178 10.0017 5.83446 10.0017C8.00946 10.0017 9.85946 8.61006 10.5428 6.6684H14.1678V8.33506C14.1678 9.25173 14.9178 10.0017 15.8345 10.0017C16.7511 10.0017 17.5011 9.25173 17.5011 8.33506V6.6684C18.4178 6.6684 19.1678 5.9184 19.1678 5.00173C19.1678 4.08506 18.4178 3.33506 17.5011 3.33506H10.5428ZM5.83446 6.6684C4.9178 6.6684 4.1678 5.9184 4.1678 5.00173C4.1678 4.08506 4.9178 3.33506 5.83446 3.33506C6.75113 3.33506 7.50113 4.08506 7.50113 5.00173C7.50113 5.9184 6.75113 6.6684 5.83446 6.6684Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKey);
export default __webpack_public_path__ + "static/media/icon_key.56d167656d415c330f118b38ce18a697.svg";
export { ForwardRef as ReactComponent };